export default {
  migrations: {
    loading: false,
    pagination: {
      search: '',
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'created_ts',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
    },
    items: [],
  },
};
